(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[24038],{

/***/ 36386:
/***/ (function(module) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),

/***/ 24038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* reexport */ Category; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@prismicio/client/dist/helpers/asText.js + 1 modules
var asText = __webpack_require__(4917);
// EXTERNAL MODULE: ./src/components/atoms/index.ts + 35 modules
var atoms = __webpack_require__(97347);
// EXTERNAL MODULE: ./src/components/layouts/index.ts + 1 modules
var layouts = __webpack_require__(25356);
// EXTERNAL MODULE: ./src/hooks/index.ts + 17 modules
var hooks = __webpack_require__(55102);
// EXTERNAL MODULE: ./src/schema/index.ts + 3 modules
var schema = __webpack_require__(34036);
// EXTERNAL MODULE: ./src/components/organisms/Faq/index.tsx
var Faq = __webpack_require__(40195);
// EXTERNAL MODULE: ../../brand/components/index.ts + 163 modules
var components = __webpack_require__(46731);
// EXTERNAL MODULE: ./src/components/organisms/index.ts + 50 modules
var organisms = __webpack_require__(79427);
;// CONCATENATED MODULE: ./src/components/pages/Category/CategoryBlog.tsx





var CategoryBlog = function(props) {
    var t = (0,hooks/* useTranslation */.$G)().t;
    var tradeCategory = (0,hooks/* useTrade */.lZ)().tradeCategory;
    var title = t("category:blog.title", {
        trade: tradeCategory === null || tradeCategory === void 0 ? void 0 : tradeCategory.toLowerCase()
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
        as: "section",
        py: 10,
        bg: "gray.50",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Container */.W2, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                    as: "h2",
                    variant: "h3",
                    mb: 10,
                    textAlign: "center",
                    children: title
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* Posts */.V8, {
                    posts: props.posts
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/components/organisms/ServicesCarousel/index.ts + 1 modules
var ServicesCarousel = __webpack_require__(33498);
;// CONCATENATED MODULE: ./src/components/pages/Category/CategoryCarousel/CategoryCarousel.tsx






var CategoryCarousel = function(param) {
    var servicesCarousels = param.servicesCarousels;
    var servicesCarouselFormatted = servicesCarousels.map(function(carousel) {
        var carouselFormatted = carousel.items.map(function(item) {
            var imageUrl = item.image.url;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                image: imageUrl
            });
        });
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, carousel), {
            items: carouselFormatted
        });
    });
    var renderCarousels = function() {
        var res = servicesCarouselFormatted.map(function(carousel) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Container */.W2, {
                py: 10,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Box */.xu, {
                        mb: 10,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                                as: "h2",
                                variant: "h3",
                                mb: 4,
                                children: asText/* asText */.S(carousel.primary.main_title)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                                as: "h3",
                                variant: "h4",
                                mb: 1,
                                children: asText/* asText */.S(carousel.primary.subtitle)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Text */.xv, {
                                children: [
                                    " ",
                                    asText/* asText */.S(carousel.primary.description)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServicesCarousel/* ServicesCarousel */.y, {
                        popularServices: carousel.items
                    })
                ]
            }, carousel.id);
        });
        return res;
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
        as: "section",
        bg: "gray.100",
        className: "CarouselGroupSection",
        children: renderCarousels()
    });
};

// EXTERNAL MODULE: ./src/utils/index.ts + 14 modules
var utils = __webpack_require__(98007);
;// CONCATENATED MODULE: ./src/components/pages/Category/CategoryHero/index.tsx
/* eslint-disable react/display-name */ // import { useEffect, useState } from 'react';
// import { isMobile } from 'react-device-detect';



// import { ButtonLink } from '@hoa/molecules';


var CategoryHero = function(param) {
    var backgroundImage = param.backgroundImage, title = param.title, subtitle = param.subtitle, ctaButtonText = param.ctaButtonText;
    // const { t } = useTranslation();
    // const [phoneNumber, setPhoneNumber] = useState<string>(``);
    var tradeQuoteUrl = (0,hooks/* useTrade */.lZ)().tradeQuoteUrl;
    // useEffect(() => {
    //   const phoneNumber = `tel:${t(`category:hero.urgency.number`)}`;
    //   setPhoneNumber(phoneNumber);
    // }, []);
    // phone number not working for now
    // const urgentRepair =
    //   trade === `electricians` ||
    //   trade === `heating-and-air-conditioning-contractors`;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Box */.xu, {
        as: "section",
        position: "relative",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                position: "absolute",
                width: "100vw",
                h: "100%",
                zIndex: -2,
                overflow: "hidden",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms/* Image */.Ee, {
                    src: backgroundImage ? backgroundImage : "",
                    alt: "Jaimy category hero image",
                    layout: "fill",
                    objectFit: "cover",
                    objectPosition: "40% 40%",
                    quality: 80,
                    loader: utils/* prismicImgixLoader */.FQ,
                    priority: true
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                position: "absolute",
                zIndex: -1,
                width: "100%",
                height: "100%",
                bg: "rgba(255, 255, 255, .55)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Container */.W2, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Flex */.kC, {
                    align: "center",
                    py: 40,
                    direction: [
                        "column",
                        null,
                        "row"
                    ],
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Box */.xu, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                                as: "h1",
                                variant: "h2",
                                mb: 4,
                                maxW: "80%",
                                children: title
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Text */.xv, {
                                as: "h2",
                                size: "lg",
                                fontWeight: 600,
                                mb: 10,
                                maxW: [
                                    "90%",
                                    null,
                                    "80%"
                                ],
                                children: subtitle
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                                textAlign: [
                                    "start",
                                    null,
                                    "start"
                                ],
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms/* Link */.rU, {
                                    href: tradeQuoteUrl,
                                    anchorProps: {
                                        _hover: {
                                            textDecoration: "none"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Button */.zx, {
                                        my: 4,
                                        variant: "solid",
                                        children: ctaButtonText
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Category_CategoryHero = (CategoryHero);

;// CONCATENATED MODULE: ./src/components/pages/Category/CategoryHighlights.tsx







var CategoryHighlights = function(props) {
    var ref = (0,hooks/* useTranslation */.$G)(), locale = ref.locale, t = ref.t;
    var highlights = (0,react.useMemo)(function() {
        return t("common:highlights", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.highlight || {
            sr_count: 61108,
            trader_count: 3153
        }), {
            returnObjects: true
        }));
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
        as: "section",
        py: 6,
        bg: "white",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Container */.W2, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* Highlights */.xK, {
                highlights: highlights
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Category/CategoryPreFooter.tsx



var CategoryPreFooter = function(param) {
    var title = param.title, subTitle = param.subTitle, button = param.button, url = param.url;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Box */.xu, {
        as: "section",
        textAlign: "center",
        py: 20,
        bg: "gray.100",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                as: "h2",
                variant: "h3",
                mb: 10,
                children: title
            }),
            subTitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                as: "h3",
                variant: "h5",
                mb: 8,
                children: subTitle
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Flex */.kC, {
                justifyContent: "center",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms/* Link */.rU, {
                    href: url,
                    anchorProps: {
                        _hover: {
                            textDecoration: "none"
                        }
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Button */.zx, {
                        children: button
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/react-alice-carousel/lib/react-alice-carousel.js
var react_alice_carousel = __webpack_require__(51253);
var react_alice_carousel_default = /*#__PURE__*/__webpack_require__.n(react_alice_carousel);
// EXTERNAL MODULE: ../../brand/theme/index.ts + 8 modules
var brand_theme = __webpack_require__(38718);
// EXTERNAL MODULE: ./src/components/molecules/index.ts + 92 modules
var molecules = __webpack_require__(11917);
;// CONCATENATED MODULE: ./src/components/pages/Category/CategoryRating/CategoryRatingReview.tsx





var CategoryRatingReview = function(props) {
    var t = (0,hooks/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Card */.Zb, {
        bg: "gray.50",
        h: "280px",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Text */.xv, {
                size: "lg",
                color: "heading",
                fontWeight: "bold",
                mb: 4,
                children: props.review.companyname
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Text */.xv, {
                size: "sm",
                mb: 2,
                maxHeight: "140px",
                overflow: "auto",
                children: props.review.description
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                mb: 2,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(molecules/* StarRating */.ZF, {
                    score: props.review.rating,
                    size: "sm",
                    justifyContent: "flex-start"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Text */.xv, {
                textTransform: "uppercase",
                size: "xs",
                color: "gray.400",
                children: [
                    t("category:jobs.rating.by"),
                    " ",
                    props.review.by
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Category/CategoryRating/CategoryRating.tsx









var CategoryRating = function(props) {
    var ref, ref1;
    var tradePlural = (0,hooks/* useTrade */.lZ)().tradePlural;
    var theme = (0,brand_theme/* useTheme */.F)();
    var score = Math.round((((ref = props.rating) === null || ref === void 0 ? void 0 : ref.avg_score) || 0) * 10) / 10;
    var carouselItemsFilter = (ref1 = props.rating) === null || ref1 === void 0 ? void 0 : ref1.reviews.filter(function(review) {
        return review.rating >= 4;
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
        as: "section",
        py: 20,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Container */.W2, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                    as: "h2",
                    variant: "h3",
                    textAlign: "center",
                    mb: 10,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms/* Trans */.cC, {
                        i18nKey: "category:jobs.rating.title",
                        components: {
                            strong: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                                as: "strong",
                                variant: "h3",
                                color: "#c5163a"
                            })
                        },
                        values: {
                            trade: tradePlural === null || tradePlural === void 0 ? void 0 : tradePlural.toLowerCase()
                        }
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                    mb: 4,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(molecules/* StarRating */.ZF, {
                        score: score
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Flex */.kC, {
                    justifyContent: "center",
                    textAlign: "center",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                                as: "span",
                                variant: "h4",
                                children: score
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Text */.xv, {
                                as: "span",
                                children: "/5"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                    mt: 8,
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(".alice-carousel__dots-item{background-color:", theme.colors.gray["200"], ";&.__active,&:hover{background-color:", theme.colors.primary.base, ";}}"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((react_alice_carousel_default()), {
                        autoWidth: true,
                        mouseTracking: true,
                        controlsStrategy: "responsive",
                        autoPlay: true,
                        animationDuration: 600,
                        autoPlayInterval: 3000,
                        infinite: true,
                        keyboardNavigation: true,
                        items: carouselItemsFilter === null || carouselItemsFilter === void 0 ? void 0 : carouselItemsFilter.map(function(review) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                                pr: 4,
                                width: "280px",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategoryRatingReview, {
                                    review: review
                                })
                            }, review.id);
                        }),
                        renderPrevButton: function() {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Button */.zx, {
                                variant: "outlineBlue",
                                mr: 2,
                                fontSize: "xl",
                                mt: 2,
                                children: "<"
                            });
                        },
                        renderNextButton: function() {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Button */.zx, {
                                variant: "outlineBlue",
                                fontSize: "xl",
                                mt: 2,
                                children: ">"
                            });
                        }
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Category/CategoryRating/index.ts


// EXTERNAL MODULE: ./src/config/index.ts + 4 modules
var config = __webpack_require__(88731);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./src/components/pages/Category/CategorySubCategories.tsx









var CategorySubCategories = function(props) {
    var ref, ref1, ref2, ref3;
    var trade = (0,hooks/* useTrade */.lZ)().trade;
    var ref4 = (0,hooks/* useTranslation */.$G)(), locale = ref4.locale, t = ref4.t;
    var router = (0,next_router.useRouter)();
    var ref5 = (0,react.useState)(""), searchQuery = ref5[0], setSearchQuery = ref5[1];
    var subCategories = ((ref1 = (ref = props.tree) === null || ref === void 0 ? void 0 : ref.children.find(function(child) {
        return child.id === config/* Category */.WD[trade];
    })) === null || ref1 === void 0 ? void 0 : ref1.children) || [];
    var onClick = function(value) {
        setSearchQuery(value);
    };
    (0,react.useEffect)(function() {
        var translateServiceRequest = t("common:generic.serviceRequest");
        var categoryUrl = router.query.trade;
        if (router.isReady && searchQuery !== "" && categoryUrl !== undefined) {
            localStorage.setItem(config/* LocalStorage.SR_SAVED_STEP */.mM.SR_SAVED_STEP, "2");
            router.push({
                pathname: "/".concat(locale, "/").concat(categoryUrl, "/").concat(translateServiceRequest, "/"),
                query: {
                    type: searchQuery
                }
            });
        }
    }, [
        searchQuery
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
        as: "section",
        bg: "gray.50",
        py: 10,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Container */.W2, {
            textAlign: "center",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                    as: "h2",
                    variant: "h3",
                    textAlign: "center",
                    mb: 10,
                    children: (ref2 = props.details) === null || ref2 === void 0 ? void 0 : ref2.primary.title
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms/* PrismicRichText */.v, {
                    render: (ref3 = props.details) === null || ref3 === void 0 ? void 0 : ref3.primary.sub_categories_description
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* SubCategories */.s0, {
                    subCategories: subCategories,
                    onSubCategoryClick: onClick
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/react-use-measure/dist/web.js
var web = __webpack_require__(731);
// EXTERNAL MODULE: ../../brand/icons/index.ts + 16 modules
var icons = __webpack_require__(36499);
;// CONCATENATED MODULE: ./src/components/pages/Category/CategoryWhyJaimy.tsx










var CategoryWhyJaimy_icons = [
    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons/* Economical */.Y4, {}),
    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons/* QualityCheck */.qt, {}),
    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons/* Assistance */.Mo, {}),
    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons/* TimeSaving */.ts, {}), 
];
var CategoryWhyJaimy = function() {
    var t = (0,hooks/* useTranslation */.$G)().t;
    var tradeCategory = (0,hooks/* useTrade */.lZ)().tradeCategory;
    var ref = (0,_sliced_to_array/* default */.Z)((0,web/* default */.Z)(), 2), ref1 = ref[0], bounds = ref[1];
    var offset = (0,react.useMemo)(function() {
        if (false) {}
        return window.innerWidth - bounds.right;
    }, [
        bounds
    ]);
    var reasons = t("category:whyJaimy.items", {
        returnObjects: true
    }).map(function(item, key) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
            icon: CategoryWhyJaimy_icons[key]
        });
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
        as: "section",
        py: 20,
        overflow: "hidden",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Container */.W2, {
            ref: ref1,
            pe: 0,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                    as: "h2",
                    variant: "h3",
                    mb: 10,
                    children: t("category:whyJaimy.title", {
                        trade: tradeCategory === null || tradeCategory === void 0 ? void 0 : tradeCategory.toLowerCase()
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Flex */.kC, {
                    mr: [
                        0,
                        null,
                        -offset
                    ],
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                            flex: [
                                null,
                                null,
                                null,
                                "0 0 65%"
                            ],
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* Reasons */._V, {
                                reasons: reasons
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                            display: [
                                "none",
                                null,
                                null,
                                "block"
                            ],
                            ml: [
                                null,
                                null,
                                4
                            ],
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                                as: "figure",
                                borderTopLeftRadius: "3xl",
                                borderBottomLeftRadius: "3xl",
                                overflow: "hidden",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                    src: "".concat("https://cdn.jaimy.be", "/images/reasons-to-choose.jpg"),
                                    alt: "Why Jaimy",
                                    loading: "lazy"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Category/Category.tsx
/* eslint-disable prettier/prettier */ 
















var Category = function(props) {
    var ref;
    var queryParam = (0,hooks/* useQueryParam */.Wd)();
    var ref1 = (0,hooks/* useTrade */.lZ)(), trade = ref1.trade, tradeQuoteUrl = ref1.tradeQuoteUrl;
    var ref2 = (0,react.useState)(""), categoryId = ref2[0], setCategoryId = ref2[1];
    var questions = (0,react.useMemo)(function() {
        var ref;
        return (ref = props.categoryPage) === null || ref === void 0 ? void 0 : ref.data.questions;
    }, [
        props.categoryPage,
        queryParam
    ]);
    var heroDetails = (0,react.useMemo)(function() {
        var ref;
        return (ref = props.categoryPage) === null || ref === void 0 ? void 0 : ref.data.body.find(function(slice) {
            return slice.slice_type === "hero_with_form";
        });
    }, [
        props.categoryPage,
        queryParam
    ]);
    var carouselDetails = (0,react.useMemo)(function() {
        var ref;
        return (ref = props.categoryPage) === null || ref === void 0 ? void 0 : ref.data.body.filter(function(slice) {
            return slice.slice_type === "cards_carousel";
        });
    }, [
        props.categoryPage,
        queryParam
    ]);
    var posts = (0,react.useMemo)(function() {
        if (!props.categoryPage) return [];
        var blogPosts = props.categoryPage.data.body.find(function(slice) {
            return slice.slice_type === "blog_posts";
        });
        return blogPosts ? blogPosts.items : [];
    }, [
        props.categoryPage,
        queryParam
    ]);
    var subCategoriesDetails = (0,react.useMemo)(function() {
        var ref;
        return (ref = props.categoryPage) === null || ref === void 0 ? void 0 : ref.data.body.find(function(slice) {
            return slice.slice_type === "sub_categories_section";
        });
    }, [
        props.categoryPage,
        queryParam
    ]);
    var preFooterDetails = (0,react.useMemo)(function() {
        var ref;
        return (ref = props.categoryPage) === null || ref === void 0 ? void 0 : ref.data.body.find(function(slice) {
            return slice.slice_type === "pre_footer";
        });
    }, [
        props.categoryPage,
        queryParam
    ]);
    (0,react.useEffect)(function() {
        if (queryParam.categoryId) setCategoryId(queryParam.categoryId);
    }, []);
    var alternativeLinks = trade ? Object.entries(schema/* TradeUrlSchema */.c).flatMap(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), locale = _param[0], value = _param[1];
        return Object.entries(value).filter(function(entry) {
            return (entry === null || entry === void 0 ? void 0 : entry[0]) === trade;
        }).map(function(value) {
            return {
                locale: locale,
                path: value === null || value === void 0 ? void 0 : value[1]
            };
        });
    }) : [];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layouts/* Layout */.A, {
        alternativeLinks: alternativeLinks,
        hasHeader: true,
        hasFooter: "small",
        children: [
            props.categoryPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms/* Seo */.pQ, {
                title: (ref = props.categoryPage) === null || ref === void 0 ? void 0 : ref.data.seo_title,
                description: props.categoryPage.data.description,
                indexed: props.categoryPage.data.page_indexed || false
            }),
            heroDetails && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Category_CategoryHero, {
                backgroundImage: heroDetails.primary.hero_image.url,
                title: heroDetails.primary.hero_title,
                subtitle: heroDetails.primary.subtitle,
                ctaButtonText: heroDetails.primary.hero_action_button_text
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategoryHighlights, {
                highlight: props.highlight
            }),
            carouselDetails && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategoryCarousel, {
                servicesCarousels: carouselDetails
            }),
            !categoryId && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategorySubCategories, {
                tree: props.tree,
                details: subCategoriesDetails
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategoryRating, {
                rating: props.rating
            }),
            questions && questions.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Faq/* default */.Z, {
                questions: questions
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategoryWhyJaimy, {}),
            posts && posts.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategoryBlog, {
                posts: posts
            }),
            preFooterDetails && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategoryPreFooter, {
                title: asText/* asText */.S(preFooterDetails.primary.pre_footer_title),
                subTitle: asText/* asText */.S(preFooterDetails.primary.pre_footer_sub_title),
                button: preFooterDetails.primary.pre_footer_cta,
                url: tradeQuoteUrl
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Category/index.ts



/***/ }),

/***/ 731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMeasure; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36386);
/* harmony import */ var debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(debounce__WEBPACK_IMPORTED_MODULE_1__);



function useMeasure(_temp) {
  let {
    debounce,
    scroll,
    polyfill,
    offsetSize
  } = _temp === void 0 ? {
    debounce: 0,
    scroll: false,
    offsetSize: false
  } : _temp;
  const ResizeObserver = polyfill || (typeof window === 'undefined' ? class ResizeObserver {} : window.ResizeObserver);

  if (!ResizeObserver) {
    throw new Error('This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills');
  }

  const [bounds, set] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    bottom: 0,
    right: 0,
    x: 0,
    y: 0
  }); // keep all state in a ref

  const state = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    element: null,
    scrollContainers: null,
    resizeObserver: null,
    lastBounds: bounds
  }); // set actual debounce values early, so effects know if they should react accordingly

  const scrollDebounce = debounce ? typeof debounce === 'number' ? debounce : debounce.scroll : null;
  const resizeDebounce = debounce ? typeof debounce === 'number' ? debounce : debounce.resize : null; // make sure to update state only as long as the component is truly mounted

  const mounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    mounted.current = true;
    return () => void (mounted.current = false);
  }); // memoize handlers, so event-listeners know when they should update

  const [forceRefresh, resizeChange, scrollChange] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    const callback = () => {
      if (!state.current.element) return;
      const {
        left,
        top,
        width,
        height,
        bottom,
        right,
        x,
        y
      } = state.current.element.getBoundingClientRect();
      const size = {
        left,
        top,
        width,
        height,
        bottom,
        right,
        x,
        y
      };

      if (state.current.element instanceof HTMLElement && offsetSize) {
        size.height = state.current.element.offsetHeight;
        size.width = state.current.element.offsetWidth;
      }

      Object.freeze(size);
      if (mounted.current && !areBoundsEqual(state.current.lastBounds, size)) set(state.current.lastBounds = size);
    };

    return [callback, resizeDebounce ? debounce__WEBPACK_IMPORTED_MODULE_1___default()(callback, resizeDebounce) : callback, scrollDebounce ? debounce__WEBPACK_IMPORTED_MODULE_1___default()(callback, scrollDebounce) : callback];
  }, [set, offsetSize, scrollDebounce, resizeDebounce]); // cleanup current scroll-listeners / observers

  function removeListeners() {
    if (state.current.scrollContainers) {
      state.current.scrollContainers.forEach(element => element.removeEventListener('scroll', scrollChange, true));
      state.current.scrollContainers = null;
    }

    if (state.current.resizeObserver) {
      state.current.resizeObserver.disconnect();
      state.current.resizeObserver = null;
    }
  } // add scroll-listeners / observers


  function addListeners() {
    if (!state.current.element) return;
    state.current.resizeObserver = new ResizeObserver(scrollChange);
    state.current.resizeObserver.observe(state.current.element);

    if (scroll && state.current.scrollContainers) {
      state.current.scrollContainers.forEach(scrollContainer => scrollContainer.addEventListener('scroll', scrollChange, {
        capture: true,
        passive: true
      }));
    }
  } // the ref we expose to the user


  const ref = node => {
    if (!node || node === state.current.element) return;
    removeListeners();
    state.current.element = node;
    state.current.scrollContainers = findScrollContainers(node);
    addListeners();
  }; // add general event listeners


  useOnWindowScroll(scrollChange, Boolean(scroll));
  useOnWindowResize(resizeChange); // respond to changes that are relevant for the listeners

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    removeListeners();
    addListeners();
  }, [scroll, scrollChange, resizeChange]); // remove all listeners when the components unmounts

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => removeListeners, []);
  return [ref, bounds, forceRefresh];
} // Adds native resize listener to window


function useOnWindowResize(onWindowResize) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const cb = onWindowResize;
    window.addEventListener('resize', cb);
    return () => void window.removeEventListener('resize', cb);
  }, [onWindowResize]);
}

function useOnWindowScroll(onScroll, enabled) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (enabled) {
      const cb = onScroll;
      window.addEventListener('scroll', cb, {
        capture: true,
        passive: true
      });
      return () => void window.removeEventListener('scroll', cb, true);
    }
  }, [onScroll, enabled]);
} // Returns a list of scroll offsets


function findScrollContainers(element) {
  const result = [];
  if (!element || element === document.body) return result;
  const {
    overflow,
    overflowX,
    overflowY
  } = window.getComputedStyle(element);
  if ([overflow, overflowX, overflowY].some(prop => prop === 'auto' || prop === 'scroll')) result.push(element);
  return [...result, ...findScrollContainers(element.parentElement)];
} // Checks if element boundaries are equal


const keys = ['x', 'y', 'top', 'bottom', 'left', 'right', 'width', 'height'];

const areBoundsEqual = (a, b) => keys.every(key => a[key] === b[key]);




/***/ })

}]);